var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"type-menu flex"},_vm._l((_vm.menu),function(item){return _c('div',{key:item.id,staticClass:"item",class:{active:item.id==_vm.$route.params.tid},domProps:{"textContent":_vm._s(item.title)},on:{"click":function($event){return _vm.goto(item.id)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }